import * as React from "react";
import SurveyRouting from "./survey-routing";

const SurveyCreate = (props) => {
    const {t} = props;
    return (
        <div>
            <SurveyRouting t={t}/>
        </div>
    );
}

export default SurveyCreate;